import "../src/global/global-pc.ts"
import "@modules/solads/solads"
import "@modules/vue-modals/ad-free"
import "@modules/webcams/pc.css"
import "@modules/webcams/webcamsVideoLogic.ts"
import { setAZMFilterPath } from "@modules/global/filter-path/filter-path-handler.ts"

setAZMFilterPath()
